import { useEventOrganizerContext } from "~contexts/outfitter-provider"
import { useUser } from "~contexts/user-provider"
import useEventOrganizer from "~utils/hooks/use-event-organizer"

export function useOnboardingEventOrganizer() {
    const { isAdminNotImpersonating } = useUser()
    const {
        eventOrganizerId,
        isLoading: isLoadingPortalEntities,
        error: errorFromPortalEntitiesQuery,
    } = useEventOrganizerContext()
    const {
        eventOrganizer,
        isLoading: isLoadingEventOrganizer,
        error: errorFromEventOrganizerQuery,
    } = useEventOrganizer({ id: eventOrganizerId })

    const isLoading = isLoadingEventOrganizer || isLoadingPortalEntities
    const hasEventOrganizerIfNeeded =
        Boolean(eventOrganizer) || isAdminNotImpersonating
    const isEventOrganizerLoading = isLoading && !hasEventOrganizerIfNeeded
    const error = errorFromEventOrganizerQuery ?? errorFromPortalEntitiesQuery

    return { eventOrganizer, isEventOrganizerLoading, error }
}
